module.exports = __webpack_public_path__ + "static/img/11.6506652.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/11.png
// module id = yDCv
// module chunks = 0